import { useEffect, useState } from "react";
import { HiMenu, HiX } from "react-icons/hi";
import { Link } from "react-router-dom";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const links = [
    { name: "Home", href: "/" },
    { name: "About Us", href: "/aboutus" },
    { name: "Contact Us", href: "/contactus" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-md" : "bg-transparent"
      }`}
    >
      {/* Main container with extra small screen padding */}
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 flex items-center justify-between h-16">

        {/* -------------------------- LOGO -------------------------- */}
        <div className="flex text-lg font-bold tracking-wide items-center space-x-1 sm:space-x-2">

          {/* CREDIBLE */}
          <Link to="/">
            <div
              className={`px-2 sm:px-3 py-1 sm:py-2 transition-all duration-300 text-center cursor-pointer rounded-md ${
                scrolled
                  ? "bg-white text-black border border-black"
                  : "bg-black text-white"
              } text-xs xs:text-sm sm:text-base`}
            >
              CREDIBLE
            </div>
          </Link>

          {/* TECHNOLOGIES */}
          <Link to="/">
            <div
              className={`px-2 sm:px-3 py-1 sm:py-2 transition-all duration-300 text-center rounded-md ${
                scrolled
                  ? "bg-black text-white"
                  : "bg-white text-black border border-black"
              } text-xs xs:text-sm sm:text-base`}
            >
              TECHNOLOGIES
            </div>
          </Link>
        </div>

        {/* -------------------------- DESKTOP NAVIGATION -------------------------- */}
        <nav className="hidden md:flex gap-4 md:gap-6 lg:gap-8 font-medium text-sm md:text-base">
          {links.map((link, idx) => (
            <Link
              key={idx}
              to={link.href}
              className={`transition duration-300 ${
                scrolled
                  ? "text-slate-800 hover:text-blue-600"
                  : "text-white hover:text-blue-400"
              }`}
            >
              {link.name}
            </Link>
          ))}
        </nav>

        {/* -------------------------- MOBILE MENU BUTTON -------------------------- */}
        <div className="md:hidden flex items-center">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className={`text-2xl focus:outline-none transition duration-300 ml-2 sm:ml-4`}
          >
            {menuOpen ? <HiX /> : <HiMenu />}
          </button>
        </div>
      </div>

      {/* -------------------------- MOBILE MENU -------------------------- */}
      <div
        className={`md:hidden bg-white shadow-md transition-all duration-300 ${
          menuOpen ? "max-h-screen" : "max-h-0 overflow-hidden"
        }`}
      >
        <nav className="flex flex-col gap-4 p-4">
          {links.map((link, idx) => (
            <a
              key={idx}
              href={link.href}
              className="text-gray-800 font-medium hover:text-blue-600 transition"
              onClick={() => setMenuOpen(false)}
            >
              {link.name}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}
